import _styled from "@emotion/styled/base";
var _excluded = ["id", "fontSize", "required", "analyticsName", "autoFocus", "content", "disabled", "errorMessage", "name", "placeholder", "resizable", "title", "unboundedWidth", "onBlur", "onChange", "onFocus", "children"];

function cov_n08qv9tw3() {
  var path = "/__w/code/code/js/packages/bricks/src/core/TextArea/TextArea.tsx";
  var hash = "dd6bf63234e8092f0f83512c72c512232e2c4985";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/TextArea/TextArea.tsx",
    statementMap: {
      "0": {
        start: {
          line: 57,
          column: 21
        },
        end: {
          line: 75,
          column: 1
        }
      },
      "1": {
        start: {
          line: 64,
          column: 34
        },
        end: {
          line: 64,
          column: 87
        }
      },
      "2": {
        start: {
          line: 67,
          column: 24
        },
        end: {
          line: 67,
          column: 60
        }
      },
      "3": {
        start: {
          line: 77,
          column: 24
        },
        end: {
          line: 82,
          column: 1
        }
      },
      "4": {
        start: {
          line: 78,
          column: 23
        },
        end: {
          line: 78,
          column: 62
        }
      },
      "5": {
        start: {
          line: 84,
          column: 42
        },
        end: {
          line: 186,
          column: 1
        }
      },
      "6": {
        start: {
          line: 104,
          column: 29
        },
        end: {
          line: 104,
          column: 51
        }
      },
      "7": {
        start: {
          line: 107,
          column: 30
        },
        end: {
          line: 112,
          column: 4
        }
      },
      "8": {
        start: {
          line: 113,
          column: 2
        },
        end: {
          line: 118,
          column: 46
        }
      },
      "9": {
        start: {
          line: 115,
          column: 4
        },
        end: {
          line: 117,
          column: 5
        }
      },
      "10": {
        start: {
          line: 116,
          column: 6
        },
        end: {
          line: 116,
          column: 89
        }
      },
      "11": {
        start: {
          line: 120,
          column: 22
        },
        end: {
          line: 127,
          column: 3
        }
      },
      "12": {
        start: {
          line: 122,
          column: 6
        },
        end: {
          line: 122,
          column: 28
        }
      },
      "13": {
        start: {
          line: 123,
          column: 6
        },
        end: {
          line: 123,
          column: 90
        }
      },
      "14": {
        start: {
          line: 129,
          column: 21
        },
        end: {
          line: 136,
          column: 3
        }
      },
      "15": {
        start: {
          line: 131,
          column: 6
        },
        end: {
          line: 131,
          column: 26
        }
      },
      "16": {
        start: {
          line: 132,
          column: 6
        },
        end: {
          line: 132,
          column: 89
        }
      },
      "17": {
        start: {
          line: 138,
          column: 23
        },
        end: {
          line: 141,
          column: 21
        }
      },
      "18": {
        start: {
          line: 139,
          column: 4
        },
        end: {
          line: 139,
          column: 88
        }
      },
      "19": {
        start: {
          line: 143,
          column: 23
        },
        end: {
          line: 148,
          column: 3
        }
      },
      "20": {
        start: {
          line: 145,
          column: 6
        },
        end: {
          line: 145,
          column: 60
        }
      },
      "21": {
        start: {
          line: 150,
          column: 2
        },
        end: {
          line: 185,
          column: 4
        }
      },
      "22": {
        start: {
          line: 188,
          column: 38
        },
        end: {
          line: 188,
          column: 96
        }
      },
      "23": {
        start: {
          line: 188,
          column: 49
        },
        end: {
          line: 188,
          column: 96
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 64,
            column: 22
          },
          end: {
            line: 64,
            column: 23
          }
        },
        loc: {
          start: {
            line: 64,
            column: 34
          },
          end: {
            line: 64,
            column: 87
          }
        },
        line: 64
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 67,
            column: 12
          },
          end: {
            line: 67,
            column: 13
          }
        },
        loc: {
          start: {
            line: 67,
            column: 24
          },
          end: {
            line: 67,
            column: 60
          }
        },
        line: 67
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 78,
            column: 11
          },
          end: {
            line: 78,
            column: 12
          }
        },
        loc: {
          start: {
            line: 78,
            column: 23
          },
          end: {
            line: 78,
            column: 62
          }
        },
        line: 78
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 84,
            column: 42
          },
          end: {
            line: 84,
            column: 43
          }
        },
        loc: {
          start: {
            line: 103,
            column: 6
          },
          end: {
            line: 186,
            column: 1
          }
        },
        line: 103
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 113,
            column: 12
          },
          end: {
            line: 113,
            column: 13
          }
        },
        loc: {
          start: {
            line: 113,
            column: 18
          },
          end: {
            line: 118,
            column: 3
          }
        },
        line: 113
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 121,
            column: 4
          },
          end: {
            line: 121,
            column: 5
          }
        },
        loc: {
          start: {
            line: 121,
            column: 50
          },
          end: {
            line: 124,
            column: 5
          }
        },
        line: 121
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 130,
            column: 4
          },
          end: {
            line: 130,
            column: 5
          }
        },
        loc: {
          start: {
            line: 130,
            column: 50
          },
          end: {
            line: 133,
            column: 5
          }
        },
        line: 130
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 138,
            column: 35
          },
          end: {
            line: 138,
            column: 36
          }
        },
        loc: {
          start: {
            line: 138,
            column: 41
          },
          end: {
            line: 141,
            column: 3
          }
        },
        line: 138
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 144,
            column: 4
          },
          end: {
            line: 144,
            column: 5
          }
        },
        loc: {
          start: {
            line: 144,
            column: 51
          },
          end: {
            line: 146,
            column: 5
          }
        },
        line: 144
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 188,
            column: 38
          },
          end: {
            line: 188,
            column: 39
          }
        },
        loc: {
          start: {
            line: 188,
            column: 49
          },
          end: {
            line: 188,
            column: 96
          }
        },
        line: 188
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 64,
            column: 34
          },
          end: {
            line: 64,
            column: 87
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 64,
            column: 55
          },
          end: {
            line: 64,
            column: 67
          }
        }, {
          start: {
            line: 64,
            column: 70
          },
          end: {
            line: 64,
            column: 87
          }
        }],
        line: 64
      },
      "1": {
        loc: {
          start: {
            line: 67,
            column: 24
          },
          end: {
            line: 67,
            column: 60
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 67,
            column: 42
          },
          end: {
            line: 67,
            column: 51
          }
        }, {
          start: {
            line: 67,
            column: 54
          },
          end: {
            line: 67,
            column: 60
          }
        }],
        line: 67
      },
      "2": {
        loc: {
          start: {
            line: 78,
            column: 23
          },
          end: {
            line: 78,
            column: 62
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 78,
            column: 46
          },
          end: {
            line: 78,
            column: 52
          }
        }, {
          start: {
            line: 78,
            column: 55
          },
          end: {
            line: 78,
            column: 62
          }
        }],
        line: 78
      },
      "3": {
        loc: {
          start: {
            line: 86,
            column: 2
          },
          end: {
            line: 86,
            column: 17
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 86,
            column: 13
          },
          end: {
            line: 86,
            column: 17
          }
        }],
        line: 86
      },
      "4": {
        loc: {
          start: {
            line: 115,
            column: 4
          },
          end: {
            line: 117,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 115,
            column: 4
          },
          end: {
            line: 117,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 115
      },
      "5": {
        loc: {
          start: {
            line: 116,
            column: 6
          },
          end: {
            line: 116,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 116,
            column: 6
          },
          end: {
            line: 116,
            column: 19
          }
        }, {
          start: {
            line: 116,
            column: 23
          },
          end: {
            line: 116,
            column: 88
          }
        }],
        line: 116
      },
      "6": {
        loc: {
          start: {
            line: 122,
            column: 6
          },
          end: {
            line: 122,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 122,
            column: 6
          },
          end: {
            line: 122,
            column: 13
          }
        }, {
          start: {
            line: 122,
            column: 17
          },
          end: {
            line: 122,
            column: 27
          }
        }],
        line: 122
      },
      "7": {
        loc: {
          start: {
            line: 123,
            column: 6
          },
          end: {
            line: 123,
            column: 89
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 123,
            column: 6
          },
          end: {
            line: 123,
            column: 19
          }
        }, {
          start: {
            line: 123,
            column: 23
          },
          end: {
            line: 123,
            column: 89
          }
        }],
        line: 123
      },
      "8": {
        loc: {
          start: {
            line: 131,
            column: 6
          },
          end: {
            line: 131,
            column: 25
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 131,
            column: 6
          },
          end: {
            line: 131,
            column: 12
          }
        }, {
          start: {
            line: 131,
            column: 16
          },
          end: {
            line: 131,
            column: 25
          }
        }],
        line: 131
      },
      "9": {
        loc: {
          start: {
            line: 132,
            column: 6
          },
          end: {
            line: 132,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 132,
            column: 6
          },
          end: {
            line: 132,
            column: 19
          }
        }, {
          start: {
            line: 132,
            column: 23
          },
          end: {
            line: 132,
            column: 88
          }
        }],
        line: 132
      },
      "10": {
        loc: {
          start: {
            line: 139,
            column: 4
          },
          end: {
            line: 139,
            column: 87
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 139,
            column: 4
          },
          end: {
            line: 139,
            column: 17
          }
        }, {
          start: {
            line: 139,
            column: 21
          },
          end: {
            line: 139,
            column: 87
          }
        }],
        line: 139
      },
      "11": {
        loc: {
          start: {
            line: 145,
            column: 24
          },
          end: {
            line: 145,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 145,
            column: 24
          },
          end: {
            line: 145,
            column: 45
          }
        }, {
          start: {
            line: 145,
            column: 49
          },
          end: {
            line: 145,
            column: 58
          }
        }],
        line: 145
      },
      "12": {
        loc: {
          start: {
            line: 152,
            column: 7
          },
          end: {
            line: 164,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 152,
            column: 7
          },
          end: {
            line: 152,
            column: 12
          }
        }, {
          start: {
            line: 152,
            column: 16
          },
          end: {
            line: 152,
            column: 18
          }
        }, {
          start: {
            line: 153,
            column: 8
          },
          end: {
            line: 163,
            column: 16
          }
        }],
        line: 152
      },
      "13": {
        loc: {
          start: {
            line: 160,
            column: 17
          },
          end: {
            line: 160,
            column: 52
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 160,
            column: 28
          },
          end: {
            line: 160,
            column: 40
          }
        }, {
          start: {
            line: 160,
            column: 43
          },
          end: {
            line: 160,
            column: 52
          }
        }],
        line: 160
      },
      "14": {
        loc: {
          start: {
            line: 177,
            column: 15
          },
          end: {
            line: 177,
            column: 28
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 177,
            column: 15
          },
          end: {
            line: 177,
            column: 22
          }
        }, {
          start: {
            line: 177,
            column: 26
          },
          end: {
            line: 177,
            column: 28
          }
        }],
        line: 177
      },
      "15": {
        loc: {
          start: {
            line: 179,
            column: 25
          },
          end: {
            line: 179,
            column: 79
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 179,
            column: 39
          },
          end: {
            line: 179,
            column: 52
          }
        }, {
          start: {
            line: 179,
            column: 55
          },
          end: {
            line: 179,
            column: 79
          }
        }],
        line: 179
      },
      "16": {
        loc: {
          start: {
            line: 179,
            column: 25
          },
          end: {
            line: 179,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 179,
            column: 25
          },
          end: {
            line: 179,
            column: 30
          }
        }, {
          start: {
            line: 179,
            column: 34
          },
          end: {
            line: 179,
            column: 36
          }
        }],
        line: 179
      },
      "17": {
        loc: {
          start: {
            line: 182,
            column: 7
          },
          end: {
            line: 182,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 182,
            column: 7
          },
          end: {
            line: 182,
            column: 19
          }
        }, {
          start: {
            line: 182,
            column: 23
          },
          end: {
            line: 182,
            column: 61
          }
        }],
        line: 182
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "dd6bf63234e8092f0f83512c72c512232e2c4985"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_n08qv9tw3 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_n08qv9tw3();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { colors, fonts, radii, fontSizesNamedWithUnits } from '../../theme/eero';
import { Box, Label, Text } from '../index';
import { ErrorPrompt } from '../../complex/ErrorPrompt';
import { bricks } from '../../system';
import { useObservabilitySafe } from '../../hooks/useObservabilitySafe';
var TextAreaBase = (cov_n08qv9tw3().s[0]++, /*#__PURE__*/_styled(bricks.textarea, process.env.NODE_ENV === "production" ? {
  target: "e15tb3as1"
} : {
  target: "e15tb3as1",
  label: "TextAreaBase"
})("width:100%;height:180px;display:block;font-size:", fontSizesNamedWithUnits.s1, ";font-family:", fonts.sans, ";border-radius:", radii.roundedSquare, ";border:2px solid ", function (props) {
  cov_n08qv9tw3().f[0]++;
  cov_n08qv9tw3().s[1]++;
  return props.errorMessage ? (cov_n08qv9tw3().b[0][0]++, colors.red50) : (cov_n08qv9tw3().b[0][1]++, colors.neutrals40);
}, ";box-sizing:border-box;padding:15px 12px;resize:", function (props) {
  cov_n08qv9tw3().f[1]++;
  cov_n08qv9tw3().s[2]++;
  return props.resizable ? (cov_n08qv9tw3().b[1][0]++, 'initial') : (cov_n08qv9tw3().b[1][1]++, 'none');
}, ";&:disabled{background:", colors.neutrals10, ";color:", colors.neutrals100, ";opacity:0.6;cursor:not-allowed;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")));
var TextAreaWrapper = (cov_n08qv9tw3().s[3]++, /*#__PURE__*/_styled(Box, process.env.NODE_ENV === "production" ? {
  target: "e15tb3as0"
} : {
  target: "e15tb3as0",
  label: "TextAreaWrapper"
})("width:", function (props) {
  cov_n08qv9tw3().f[2]++;
  cov_n08qv9tw3().s[4]++;
  return props.unboundedWidth ? (cov_n08qv9tw3().b[2][0]++, '100%') : (cov_n08qv9tw3().b[2][1]++, '350px');
}, ";@media (max-width: 768px){width:100%;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")));
cov_n08qv9tw3().s[5]++;

var TextArea = function TextArea(_ref) {
  var id = _ref.id,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? (cov_n08qv9tw3().b[3][0]++, 's1') : _ref$fontSize,
      required = _ref.required,
      analyticsName = _ref.analyticsName,
      autoFocus = _ref.autoFocus,
      content = _ref.content,
      disabled = _ref.disabled,
      errorMessage = _ref.errorMessage,
      name = _ref.name,
      placeholder = _ref.placeholder,
      resizable = _ref.resizable,
      title = _ref.title,
      unboundedWidth = _ref.unboundedWidth,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  cov_n08qv9tw3().f[3]++;

  var _ref2 = (cov_n08qv9tw3().s[6]++, useObservabilitySafe()),
      trackUserEvent = _ref2.trackUserEvent; // tracks impression events


  var _ref3 = (cov_n08qv9tw3().s[7]++, useInView({
    // https://react-intersection-observer.vercel.app/?path=/docs/useinview-hook--basic
    // threshold: Number between 0 and 1 indicates the percentage that should be visible before triggering. (set at 100% for now)
    threshold: 1,
    skip: !analyticsName
  })),
      _ref4 = _slicedToArray(_ref3, 2),
      inViewRef = _ref4[0],
      inView = _ref4[1];

  cov_n08qv9tw3().s[8]++;
  useEffect(function () {
    cov_n08qv9tw3().f[4]++;
    cov_n08qv9tw3().s[9]++;

    // this tracks impression events whenenver the input enters or leaves the viewpoint
    if (inView) {
      cov_n08qv9tw3().b[4][0]++;
      cov_n08qv9tw3().s[10]++;
      (cov_n08qv9tw3().b[5][0]++, analyticsName) && (cov_n08qv9tw3().b[5][1]++, trackUserEvent({
        inputViewEvent: {
          targetName: analyticsName
        }
      }));
    } else {
      cov_n08qv9tw3().b[4][1]++;
    }
  }, [inView, analyticsName, trackUserEvent]);
  var handleFocus = (cov_n08qv9tw3().s[11]++, useCallback(function (e) {
    cov_n08qv9tw3().f[5]++;
    cov_n08qv9tw3().s[12]++;
    (cov_n08qv9tw3().b[6][0]++, onFocus) && (cov_n08qv9tw3().b[6][1]++, onFocus(e));
    cov_n08qv9tw3().s[13]++;
    (cov_n08qv9tw3().b[7][0]++, analyticsName) && (cov_n08qv9tw3().b[7][1]++, trackUserEvent({
      inputFocusEvent: {
        targetName: analyticsName
      }
    }));
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [onFocus, analyticsName]));
  var handleBlur = (cov_n08qv9tw3().s[14]++, useCallback(function (e) {
    cov_n08qv9tw3().f[6]++;
    cov_n08qv9tw3().s[15]++;
    (cov_n08qv9tw3().b[8][0]++, onBlur) && (cov_n08qv9tw3().b[8][1]++, onBlur(e));
    cov_n08qv9tw3().s[16]++;
    (cov_n08qv9tw3().b[9][0]++, analyticsName) && (cov_n08qv9tw3().b[9][1]++, trackUserEvent({
      inputBlurEvent: {
        targetName: analyticsName
      }
    }));
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [onBlur, analyticsName]));
  var onMouseEnter = (cov_n08qv9tw3().s[17]++, useCallback(function () {
    cov_n08qv9tw3().f[7]++;
    cov_n08qv9tw3().s[18]++;
    (cov_n08qv9tw3().b[10][0]++, analyticsName) && (cov_n08qv9tw3().b[10][1]++, trackUserEvent({
      inputHoverEvent: {
        targetName: analyticsName
      }
    })); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [analyticsName]));
  var handleChange = (cov_n08qv9tw3().s[19]++, useCallback(function (e) {
    cov_n08qv9tw3().f[8]++;
    cov_n08qv9tw3().s[20]++;
    onChange(e, name, (cov_n08qv9tw3().b[11][0]++, e.currentTarget.value) || (cov_n08qv9tw3().b[11][1]++, undefined));
  }, [name, onChange]));
  cov_n08qv9tw3().s[21]++;
  return /*#__PURE__*/React.createElement(TextAreaWrapper, {
    className: 'od-multi-line-input',
    unboundedWidth: unboundedWidth
  }, (cov_n08qv9tw3().b[12][0]++, title) && (cov_n08qv9tw3().b[12][1]++, id) && (cov_n08qv9tw3().b[12][2]++, /*#__PURE__*/React.createElement(Label, {
    htmlFor: id,
    id: "".concat(id, "-label"),
    fontSize: fontSize,
    required: required,
    display: "block",
    pb: [2, 3],
    color: disabled ? (cov_n08qv9tw3().b[13][0]++, 'neutrals70') : (cov_n08qv9tw3().b[13][1]++, undefined)
  }, title)), /*#__PURE__*/React.createElement(TextAreaBase, _extends({
    autoFocus: autoFocus,
    className: "form-input",
    disabled: disabled,
    name: name,
    onBlur: handleBlur,
    onChange: handleChange,
    onFocus: handleFocus,
    onMouseEnter: onMouseEnter,
    placeholder: placeholder,
    ref: inViewRef,
    resizable: resizable,
    value: (cov_n08qv9tw3().b[14][0]++, content) || (cov_n08qv9tw3().b[14][1]++, ''),
    errorMessage: errorMessage,
    "aria-labelledby": (cov_n08qv9tw3().b[16][0]++, title) && (cov_n08qv9tw3().b[16][1]++, id) ? (cov_n08qv9tw3().b[15][0]++, "".concat(id, "-label")) : (cov_n08qv9tw3().b[15][1]++, props['aria-labelledby'])
  }, props)), (cov_n08qv9tw3().b[17][0]++, errorMessage) && (cov_n08qv9tw3().b[17][1]++, /*#__PURE__*/React.createElement(ErrorPrompt, {
    message: errorMessage
  })), /*#__PURE__*/React.createElement(HelpText, null, children));
};

cov_n08qv9tw3().s[22]++;

var HelpText = function HelpText(props) {
  cov_n08qv9tw3().f[9]++;
  cov_n08qv9tw3().s[23]++;
  return /*#__PURE__*/React.createElement(Text, _extends({
    fontSize: "s1",
    mt: 3,
    mb: 0
  }, props));
};

export default TextArea;